import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';

const Booking = () => (
  <div>
    <Breadcrumbs 
      aria-label="breadcrumb"
      style={{
          marginLeft: '8px',
          marginBottom: '5px',
        }}
    >
      
      <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
      <Typography sx={{ color: 'text.primary' }}>Booking</Typography>
    
    </Breadcrumbs>
    <DefaultTabsBorderedBottom />
  </div>
  );

export default Booking;
